import { LTButton } from '@/components/design-system/atoms/actions/LTButton'

export const LTAtomsActions = {
  Button: LTButton
}
